import { CSSProperties, HTMLAttributes } from 'react';
import { TooltipPositionerPointObject } from 'highcharts';
import EditIcon from '@mui/icons-material/Edit';

import { Annotation } from 'common/graphqlTypes';
import IconButton from 'components/common/IconButton/IconButton';

import './AnnotationTooltip.scss';

export type AnnotationData = {
  annotation: Annotation;
  graphSeries: TooltipPositionerPointObject[];
};
type AnnotationTooltipProps = HTMLAttributes<HTMLDivElement> & {
  annotationData: AnnotationData;
  onEdit: () => void;
};

export function AnnotationTooltip(props: AnnotationTooltipProps): JSX.Element {
  const MARGIN = 16;
  const { annotationData, onEdit, ...rest } = props;

  function calcTooltipPosition(): CSSProperties {
    const { graphSeries } = annotationData;

    // Annotation is a rectangular polygon.
    // We want to position the tooltip just below this rectangle, centered
    const annotationBottomCenterX = Math.floor((graphSeries[0].plotX + graphSeries[1].plotX) / 2);
    const annotationBottomY = Math.floor(graphSeries[0].plotY);

    return {
      left: annotationBottomCenterX,
      top: annotationBottomY + MARGIN,
    };
  }

  return (
    <div
      style={{ position: 'absolute', ...calcTooltipPosition() }}
      className="AnnotationTooltip__Body"
      {...rest}
    >
      <span style={{ color: annotationData.annotation.color }}>●</span>
      <span>{annotationData.annotation.comment}</span>
      <IconButton icon={<EditIcon fontSize="small" />} showTooltip={false} onClick={onEdit} />
    </div>
  );
}
